import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

// The lockup is MissFit-supplied artwork with a real alpha channel, so it sits on the
// app's light surfaces as artwork rather than as a navy plate. The glyph still carries a
// baked navy #002147 background and is built to read as a solid badge — do not tint it.
// The automated client emails deliberately do NOT use these files: BRAND.logoUrl in
// backend/layers/helpers/nodejs/email-templates.mjs still points at the older
// /email-assets/missfit-logo.png, because mail already delivered to a client refetches
// that URL every time it is opened and must keep rendering what it was built with.
const ASSETS = {
  lockup: { src: '/brand/missfit-lockup-transparent.png', aspect: 944 / 297 },
  glyph: { src: '/brand/missfit-glyph.png', aspect: 1 },
} as const

interface BrandLogoProps {
  /** 'lockup' includes the MissFit Mindset wordmark; 'glyph' is the roofline mark alone. */
  variant?: keyof typeof ASSETS
  /** Rendered height in px. Width is derived from the asset's aspect ratio. */
  height?: number
  /** Pass '' where the logo is decorative and adjacent text already names the brand. */
  alt?: string
  sx?: SxProps<Theme>
}

export default function BrandLogo({
  variant = 'lockup',
  height = 32,
  alt = 'MissFit Mindset',
  sx,
}: BrandLogoProps) {
  const { src, aspect } = ASSETS[variant]

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{ display: 'block', flexShrink: 0, height, width: height * aspect, ...sx }}
    />
  )
}
